<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Average Net Income Per Deal</h3>
        </div>

        <div class="mt-2 text-center">
            <span class="card-value"><h2>${{ value }}</h2></span>
            <span class="card-change"></span>
            <small class="dashboard-stats-label">Average Net Commission ex GST</small>
        </div>
    </el-card>
</template>

<script>
import RadialGauge from 'vue2-canvas-gauges/src/RadialGauge'

export default {
    name: 'AverageIncomeCard',
    components: {
        RadialGauge
    },
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            averageIncomeData: [],
            value: 0
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.averageIncomeData = event.avgIncome.averageIncome

            this.value = this.averageIncomeData.shortAvg.toFixed(0)
            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.averageIncomeData = event.avgIncome.averageIncome

            this.value = this.averageIncomeData.shortAvg.toFixed(0)

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    watch: {},
    computed: {},
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style lang="scss" scoped>
.radial-guage-container {
    overflow: hidden;
    max-width: 450px;
    margin: 0 auto;

    .canvas-gauges.radial-guage-component {
        margin-bottom: calc(-40%);
    }
}

.dash-avg-stats-container {
    .card-body {
        text-align: center !important;
    }

    .card-value {
        margin-left: auto !important;
        margin-right: auto !important;
    }
}
</style>

<style lang="scss">
.dash-avg-stats-container {
    .card-body {
        text-align: center !important;
    }

    .card-value {
        margin-left: auto !important;
        margin-right: auto !important;
    }
}
</style>
